
import * as THREE from 'three';

export class ModelMaker {
    thickness = 2; // 厚度
    baseThickness = 2; // 底盘厚度
    baseRadius = 20; // 底盘半径
    scale = 0.2; // 像素到毫米的转换比例
    baseType = "type1"; // 底盘类型
    baseDist = 10; // 弯折部分长度

    constructor() { }
    
    init(scene) {
        this.group = new THREE.Group();
        let geom = new THREE.BufferGeometry();
        geom.setAttribute("position", new THREE.BufferAttribute(new Float32Array(), 3));
        // let material = new THREE.MeshNormalMaterial({
        let material = new THREE.MeshPhongMaterial({
            // let material = new THREE.MeshLambertMaterial({
            // wireframe: true,
            flatShading: true,
        });
        this.mesh = new THREE.Mesh(geom, material);
        // this.mesh.rotation.x = Math.PI * 0.5;
        // this.mesh.position.z = -this.thickness * 0.5;
        this.group.add(this.mesh);

        // this.mesh2 = new THREE.Mesh(geom, material);
        // this.mesh2.rotation.y = Math.PI * 0.5;
        // this.mesh2.position.x = -this.thickness * 0.5;
        // this.group.add(this.mesh2);

        scene.add(this.group);
    }

    updateGeometry(vertices) {
        this.mesh.geometry.attributes.position = new THREE.BufferAttribute(new Float32Array(vertices), 3);
        this.mesh.geometry.center();
    }

    addBounds(vertices, ps, z1, z2) {
        // 内壁
        for (let i = 0, last = ps[ps.length - 1]; i < ps.length; i++) {
            let curr = ps[i];
            vertices.push(last.x, last.y, z1, curr.x, curr.y, z2, curr.x, curr.y, z1);
            vertices.push(last.x, last.y, z1, last.x, last.y, z2, curr.x, curr.y, z2);
            last = curr;
        }
    }

    // 圆盘，有厚度
    addDiskY(vertices, center, radius, N, y1, y2) {
        let ps = [];
        for (let i = 0; i < N; i++) {
            let rad = i / N * Math.PI * 2;
            let x = center.x + radius * Math.cos(rad);
            let y = center.y + radius * Math.sin(rad);
            ps.push(new THREE.Vector2(x, y));
        }

        for (let i = 0, last = ps[ps.length - 1], curr = ps[i]; i < ps.length; i++, last = curr, curr = ps[i]) {
            vertices.push(center.x, y1, center.y, curr.x, y1, curr.y, last.x, y1, last.y);
        }

        for (let i = 0, last = ps[ps.length - 1], curr = ps[i]; i < ps.length; i++, last = curr, curr = ps[i]) {
            vertices.push(center.x, y2, center.y, last.x, y2, last.y, curr.x, y2, curr.y);
        }

        // 内壁
        for (let i = 0, last = ps[ps.length - 1]; i < ps.length; i++) {
            let curr = ps[i];
            vertices.push(last.x, y1, last.y, curr.x, y1, curr.y, curr.x, y2, curr.y);
            vertices.push(last.x, y1, last.y, curr.x, y2, curr.y, last.x, y2, last.y);
            last = curr;
        }
    }

    // 圆盘，有厚度
    addDiskZ(vertices, center, radius, N, z1, z2) {
        let ps = [];
        for (let i = 0; i < N; i++) {
            let rad = i / N * Math.PI * 2;
            let x = center.x + radius * Math.cos(rad);
            let y = center.y + radius * Math.sin(rad);
            ps.push(new THREE.Vector2(x, y));
        }

        for (let i = 0, last = ps[ps.length - 1], curr = ps[i]; i < ps.length; i++, last = curr, curr = ps[i]) {
            vertices.push(center.x, center.y, z1, curr.x, curr.y, z1, last.x, last.y, z1);
        }

        for (let i = 0, last = ps[ps.length - 1], curr = ps[i]; i < ps.length; i++, last = curr, curr = ps[i]) {
            vertices.push(center.x, center.y, z2, last.x, last.y, z2, curr.x, curr.y, z2);
        }

        // 内壁
        for (let i = 0, last = ps[ps.length - 1]; i < ps.length; i++) {
            let curr = ps[i];
            vertices.push(last.x, last.y, z1, curr.x, curr.y, z1, curr.x, curr.y, z2);
            vertices.push(last.x, last.y, z1, curr.x, curr.y, z2, last.x, last.y, z2);
            last = curr;
        }
    }

    // 由两条等长线段加厚度构成的管道，全部闭合。
    addBoxChainX(vertices, ps1, ps2, x1, x2) {
        for (let i = 1, last1 = ps1[0], last2 = ps2[0]; i < ps1.length; i++) {
            let curr1 = ps1[i];
            let curr2 = ps2[i];
            vertices.push(x1, last1.x, last1.y, x1, curr1.x, curr1.y, x1, curr2.x, curr2.y);
            vertices.push(x1, last1.x, last1.y, x1, curr2.x, curr2.y, x1, last2.x, last2.y);

            vertices.push(x2, last1.x, last1.y, x2, curr2.x, curr2.y, x2, curr1.x, curr1.y);
            vertices.push(x2, last1.x, last1.y, x2, last2.x, last2.y, x2, curr2.x, curr2.y);
            last1 = curr1;
            last2 = curr2;
        }

        let ps = [...ps1, ...ps2.reverse()];
        for (let i = 0, last = ps[ps.length - 1]; i < ps.length; i++) {
            let curr = ps[i];
            vertices.push(x1, last.x, last.y, x2, curr.x, curr.y, x1, curr.x, curr.y);
            vertices.push(x1, last.x, last.y, x2, last.x, last.y, x2, curr.x, curr.y);
            last = curr;
        }
    }

    makeModel({ polytree, startPoint }) {
        let vertices = [];
        let s = this.scale;
        let fPointToVector2 = p => new THREE.Vector2(p.X * s, p.Y * s);
        startPoint = startPoint.clone().multiplyScalar(s);
        // 只有一层
        for (let i = 0, nodes = polytree.Childs(), z = this.thickness; i < nodes.length; i++) {
            let node = nodes[i];
            let path = {
                shape: node.Contour().map(fPointToVector2),
                holes: node.Childs().map(holeNode => holeNode.Contour().map(fPointToVector2))
            };

            const faces = THREE.ShapeUtils.triangulateShape(path.shape, path.holes);
            let points = [...path.shape];
            path.holes.forEach(hole => { points.push(...hole); });
            faces.forEach(f => {
                let p1 = points[f[0]];
                let p2 = points[f[1]];
                let p3 = points[f[2]];
                vertices.push(p1.x, p1.y, 0);
                vertices.push(p3.x, p3.y, 0);
                vertices.push(p2.x, p2.y, 0);
                vertices.push(p1.x, p1.y, z);
                vertices.push(p2.x, p2.y, z);
                vertices.push(p3.x, p3.y, z);
            });
            // for (let i = 0, ps = path.shape, last = ps[ps.length - 1]; i < ps.length; i++) {
            //     let curr = ps[i];
            //     if (startPoint.y !== last.y || startPoint.y !== curr.y) {
            //         vertices.push(last.x, last.y, z, curr.x, curr.y, 0, curr.x, curr.y, z);
            //         vertices.push(last.x, last.y, z, last.x, last.y, 0, curr.x, curr.y, 0);
            //     }
            //     last = curr;
            // }
            this.addBounds(vertices, path.shape, z, 0);
            path.holes.forEach(hole => { this.addBounds(vertices, hole, z, 0); });
            // node.Childs().forEach(subNode => { nodes.push(...subNode.Childs()); });
        }

        if (this.baseType === "type1") {
            this.addDiskY(vertices, new THREE.Vector2(startPoint.x, 0), this.baseRadius, 256, startPoint.y, startPoint.y - this.baseThickness);
        } else if (this.baseType === "type2") {
            // 连接管
            const radius = 2;
            const radius2 = radius + this.thickness;
            let ps1 = [], ps2 = [];
            const N = 32;
            const center = new THREE.Vector2(startPoint.y, -radius);
            for (let i = 0; i <= N; i++) {
                let rad = i / N * Math.PI * 0.5 + Math.PI;
                let x = center.x + radius2 * Math.cos(rad);
                let y = center.y - radius2 * Math.sin(rad);
                ps1.push(new THREE.Vector2(x, y)); // 外侧
                x = center.x + radius * Math.cos(rad);
                y = center.y - radius * Math.sin(rad);
                ps2.push(new THREE.Vector2(x, y)); // 内侧
            }
            ps1.unshift(new THREE.Vector2(startPoint.y - radius2, -this.baseDist));
            ps2.unshift(new THREE.Vector2(startPoint.y - radius, -this.baseDist));
            this.addBoxChainX(vertices, ps1, ps2, startPoint.x - 2 * s, startPoint.x + 2 * s);

            this.addDiskZ(vertices, new THREE.Vector2(startPoint.x, startPoint.y - radius + this.thickness * 0.5), this.baseRadius, 256, -this.baseDist - this.baseThickness, -this.baseDist);
        }


        this.updateGeometry(vertices);
    }
}


// WEBPACK FOOTER //
// ./src/views/makeLeaf/scripts/ModelMaker.js